/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA
 */

import { resolveActiveApplicationLocale } from '@oat-sa-private/ui-core/time';
import { applyDateFormatSettings, DEFAULT_DATE_FORMAT_LOCALE } from '@/core/utils/dateFormatApply.js';
import { configurationStore } from '@/stores/tenantConfiguration.store.js';

/**
 * Re-applies tenant date format settings using the active application locale.
 */
export async function syncDateFormatConfig() {
    const configuration = configurationStore.get();

    if (!configuration) {
        return;
    }

    const settings = configurationStore.getDateFormats();
    const activeLocale = resolveActiveApplicationLocale(configuration.locale) || DEFAULT_DATE_FORMAT_LOCALE;

    await applyDateFormatSettings({
        enabled: settings?.enabled ?? false,
        dateFormats: settings?.dateFormats ?? {},
        locale: activeLocale
    });
}
